export enum ORDER_TYPE {
  'ALL' = 'ALL',
  'DINE-IN' = 'DINE-IN',
  'DINE_IN' = 'DINE-IN',
  'TAKEAWAY' = 'TAKEAWAY',
}
